import { render, staticRenderFns } from "./FotoVerso.vue?vue&type=template&id=22ed87a9&scoped=true&"
import script from "./FotoVerso.vue?vue&type=script&lang=js&"
export * from "./FotoVerso.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22ed87a9",
  null
  
)

export default component.exports